var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBoxesStacked = function SvgBoxesStacked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 4H8v7h8V4h-2.75v3h-2.5zm-4.5 8H3v8h9v-8H8.75v3h-2.5zM21 20v-8h-3.25v3h-2.5v-3H13v8z"
  })));
};
export default SvgBoxesStacked;